import { useMemo } from 'react';
import { type TestProps } from '@direct-frontend/components';
import { ONBOARDING_EXTERNAL_CHECKOUT_STEPS } from '#shared/api/onboarding';
import { checkIsBitrixStore } from '#shared/lib/storeInfo';
import { checkoutSubtasksProps, getCheckoutStepsProps } from '../../model/onboardingCheckoutStages';
import { OnboardingStepsRenderer } from '../OnboardingStepsRenderer';
import { ExternalPublishButton } from './ExternalPublishButton';

export function ExternalOnboardingStepper(props: TestProps) {
    const isBitrix = checkIsBitrixStore();
    const stepsProps = useMemo(() => getCheckoutStepsProps(isBitrix), [isBitrix]);

    return (
        <OnboardingStepsRenderer
            {...props}
            PublishButton={ExternalPublishButton}
            publishSlug={ONBOARDING_EXTERNAL_CHECKOUT_STEPS.PUBLISH}
            stepsProps={stepsProps}
            subtasksProps={checkoutSubtasksProps}
        />
    );
}
